var _path, _path2, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditorExitPreview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 13C16.75 13.862 16.4076 14.6886 15.7981 15.2981C15.1886 15.9076 14.362 16.25 13.5 16.25C12.638 16.25 11.8114 15.9076 11.2019 15.2981C10.5924 14.6886 10.25 13.862 10.25 13C10.25 12.138 10.5924 11.3114 11.2019 10.7019C11.8114 10.0924 12.638 9.75 13.5 9.75C14.362 9.75 15.1886 10.0924 15.7981 10.7019C16.4076 11.3114 16.75 12.138 16.75 13Z",
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 12.9998C4.40033 8.56142 8.44766 5.4165 13.5003 5.4165C18.553 5.4165 22.6003 8.56142 24.3337 12.9998C22.6003 17.4383 18.553 20.5832 13.5003 20.5832C8.44766 20.5832 4.40033 17.4383 2.66699 12.9998Z",
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.26777,
    y1: 5,
    x2: 21.5,
    y2: 21.2322,
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorExitPreview);
export default __webpack_public_path__ + "static/media/editor-exit-preview.71b9728196d55654ecdf3a564f1ba0df.svg";
export { ForwardRef as ReactComponent };